export default __webpack_public_path__ + "static/media/WalkingGroupImage4.aae9193e.png";